"use strict";

require("core-js/modules/es.symbol.description.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LazyLoadElements = LazyLoadElements;
exports.LazyLoadRoute = LazyLoadRoute;
exports.LazyRouterElement = LazyRouterElement;
exports.LinkElement = LinkElement;
exports.RouterElement = RouterElement;
exports.RouterElement_v2 = exports.RouterElement_v1 = void 0;
exports.RouterElement_v3 = RouterElement_v3;
require("core-js/modules/es.promise.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRouterDom = require("react-router-dom");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// https://dev.to/mondal10/react-router-lazy-load-route-components-4df

function LazyLoadRoute(element) {
  // const LazyElement = lazy(() => import(`/src/pages/${element}.js`))
  console.log(element);
  const lazyPath = "../../pages/".concat(element, ".js");
  console.log(lazyPath);
  const LazyElement = /*#__PURE__*/(0, _react.lazy)(() => (specifier => new Promise(r => r("".concat(specifier))).then(s => _interopRequireWildcard(require(s))))(lazyPath.toLowerCase()));
  console.log(LazyElement);
  const newElement = /*#__PURE__*/_react.default.createElement(_react.Suspense, {
    fallback: "Loading..."
  }, /*#__PURE__*/_react.default.createElement(LazyElement, null));
  console.log(newElement);
  return newElement;
}
function LazyLoadElements(props) {
  console.log('LazyLoadElements');
  const elements = props.routes.map(thisRoute => {
    console.log(thisRoute.element);
    const lazyPath = ".".concat(__dirname, "pages/").concat(thisRoute.element, ".js");
    console.log(lazyPath);
    const LazyElement = /*#__PURE__*/(0, _react.lazy)(() => (specifier => new Promise(r => r("".concat(specifier))).then(s => _interopRequireWildcard(require(s))))(lazyPath.toLowerCase()));
    console.log(LazyElement);
    const newElement = /*#__PURE__*/_react.default.createElement(_react.Suspense, {
      fallback: "Loading..."
    }, /*#__PURE__*/_react.default.createElement(LazyElement, null));
    console.log(newElement);
    return newElement;
  });
  return elements;
}
function LazyRouterElement(props) {
  const routes = props.routes.map(thisRoute => ({
    path: thisRoute.path,
    element: LazyLoadRoute(thisRoute.element)
  }));
  return (0, _reactRouterDom.useRoutes)(routes);
}
function RouterElement(props) {
  console.log(props.routes);
  const newroutes = props.routes.map(thisRoute => {
    // const NewElement = thisRoute.element;
    // console.log(NewElement)
    const newLazyElement = {
      path: thisRoute.path,
      element: LazyLoadRoute(thisRoute.element) // <NewElement />
    };

    console.log(newLazyElement);
    return newLazyElement;
  });
  console.log(newroutes);
  return (0, _reactRouterDom.useRoutes)(newroutes);
}
RouterElement.propTypes = {
  routes: _propTypes.default.array.isRequired
};

// eslint-disable-next-line camelcase
function RouterElement_v3(props) {
  // <RouterElement routes={this.props.routes} />
  const newroutes = (0, _reactRouterDom.useRoutes)(props.routes);
  return newroutes;
}

// eslint-disable-next-line camelcase
class RouterElement_v2 extends _react.Component {
  render() {
    const newroutes = (0, _reactRouterDom.useRoutes)(this.props.routes);
    return /*#__PURE__*/_react.default.createElement(_reactRouterDom.BrowserRouter, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Routes, null, newroutes));
  }
}

// eslint-disable-next-line camelcase
exports.RouterElement_v2 = RouterElement_v2;
// <RouterElement routes={this.props.routes} />
_defineProperty(RouterElement_v2, "propTypes", {
  routes: _propTypes.default.array.isRequired
});
class RouterElement_v1 extends _react.Component {
  render() {
    const newroutes = this.props.routes.map((thisRoute, i) => {
      const ThisElement = thisRoute.element;
      return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
        key: i + '-' + thisRoute.element,
        path: "".concat(thisRoute.path),
        element: /*#__PURE__*/_react.default.createElement(ThisElement)
      });
    });
    return /*#__PURE__*/_react.default.createElement(_reactRouterDom.BrowserRouter, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Routes, null, newroutes));
  }
}
exports.RouterElement_v1 = RouterElement_v1;
// <RouterElement routes={this.props.routes} />
_defineProperty(RouterElement_v1, "propTypes", {
  routes: _propTypes.default.array.isRequired
});
function LinkElement(props) {
  const links = props.routes.map((thisRoute, i) => /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    key: i + '-' + thisRoute.element,
    to: thisRoute.path
  }, thisRoute.element));
  return links;
}